import { GetServerSidePropsContext } from 'next';
import { ShopSearchRawQueryParams } from 'models/ShopSearchRawQueryParams';
import { nextQueryFirstString } from './normalizeShopSearchRawQuery';
import { STATUS_CODES } from './statusCodes';

export const transformQueryParamsToApiParams = (
  context: GetServerSidePropsContext
) => {
  const query = context.query as ShopSearchRawQueryParams;
  const category = nextQueryFirstString(query.category) || '';
  const searchTerm = nextQueryFirstString(query.q) || '';
  const keyword = nextQueryFirstString(query.keyword) || '';
  const account = nextQueryFirstString(query.account) || '';
  const sort = nextQueryFirstString(query.sort) || '';
  const hasValidCertificate = Object.prototype.hasOwnProperty.call(
    query,
    'hasValidCertificate'
  );
  const pageStr = nextQueryFirstString(query.page);
  const page = pageStr ? parseInt(pageStr, 10) : 1;
  if (isNaN(page)) {
    throw STATUS_CODES.BAD_REQUEST;
  }

  return {
    category,
    searchTerm,
    keyword,
    account,
    sort,
    hasValidCertificate,
    page: (page - 1).toString()
  };
};
